<button mat-icon-button class="popup" [ngClass]="{ 'disable-hover': disableHover }" (click)="onIconClick()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  @if (!isHovered || disableHover) {
  <img [src]="iconSrc" alt="{{ title }}" />
  } @if (isHovered && !disableHover) {
  <img [src]="iconSrcHover" alt="{{ title }}" />
  }
</button>
